import ProjectCard from "../../Components/ProjectCard";
import { useContext } from "react";
import { BlogsContext } from "../../utils/context";
import { variants } from "../../utils/animations";
import { motion } from "framer-motion";
import { BsArrowUpRight } from "react-icons/bs";
import "./styles.css";

const Writing = () => {
  const blogsData = useContext(BlogsContext);
  const blogs = blogsData.filter((v) => v.type === "stories");

  return (
    <>
      <motion.div
        initial='hidden'
        whileInView='visible'
        variants={variants}
        className='writing__container'
      >
        <motion.div variants={variants} className='writing__title'>
          <motion.h1 variants={variants}>
            My work centers on the intersection of identity, cultural diversity,
            representation, belonging, and linguistic integrity.
          </motion.h1>

          <motion.a
            variants={variants}
            className='writing__bookLink'
            href='https://www.amazon.co.uk/s?k=moubani+roy+choudhury&crid=ZVUF1VICIMT7&sprefix=moub,aps,307'
            target='_blank'
            rel='noopener noreferrer'
          >
            Explore my book collection <BsArrowUpRight />
          </motion.a>

          <h3>STORIES</h3>
        </motion.div>

        {blogs?.map((item) => (
          <ProjectCard
            key={item.guid}
            title={item.title}
            thumbnail={item.thumbnail}
            description={item.description}
            content={item.content}
            timestamp={item.pubDate}
            subtitle={/(?:<.+?>)([^<>]*?)(?:<\/.*?>)/g.exec(item.content)[1]}
            width={"wide"}
          />
        ))}
      </motion.div>
    </>
  );
};

export default Writing;
